export default __webpack_public_path__ + "static/media/right-front-three-quarter-11.5c4ae904.jpeg";